import { toInlineStyle } from '@/features/_shared/lib/legacyStyle';

const PremiumFeatureMessage = ({ sx }: { sx?: unknown }) => (
  <>
    <p style={toInlineStyle(sx)}>This feature isn't included in your plan.</p>
    <p style={toInlineStyle(sx)}>Upgrade for advanced functionality.</p>
  </>
);

export default PremiumFeatureMessage;
